import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

export const HeroSection = () => {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero-section relative min-h-screen flex items-center justify-center overflow-hidden bg-white pt-20">
      {/* Abstract background shapes */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="abstract-shape shape-1"></div>
        <div className="abstract-shape shape-2"></div>
      </div>

      <div className="container-custom relative z-10">
        <div className="max-w-5xl mx-auto fade-in-section">
          <h1 className="hero-title mb-8 text-center">
            Votre entreprise vaut peut-être plus<br />
            que ce que vos prospects en <span className="text-accent">perçoivent</span>.
          </h1>
          
          <div className="max-w-3xl mx-auto space-y-6 text-lg text-gray-700 leading-relaxed mb-12">
            <p>
              Vous connaissez la qualité de votre travail. Vos clients actuels la connaissent également.
            </p>
            <p>
              Mais un nouveau prospect, lui, ne voit que les signaux que vous lui envoyez : votre message, vos offres, votre site, vos supports et la manière dont vous vous présentez.
            </p>
            <p>
              Lorsque ces signaux ne traduisent pas correctement votre valeur, votre entreprise paraît plus banale, plus complexe ou moins rassurante qu'elle ne l'est réellement.
            </p>
            <p className="font-semibold text-gray-900">
              Le Gap de Perception identifie cet écart et détermine ce qu'il faut corriger avant d'investir dans de nouvelles actions de communication.
            </p>
          </div>

          <div className="flex flex-col items-center gap-6">
            <Button 
              onClick={scrollToContact}
              className="cta-button group"
              size="lg"
            >
              Demander un premier échange
              <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </Button>
            
            <p className="text-sm text-gray-600">
              Diagnostic stratégique : <span className="font-semibold text-gray-900">700 €</span> — Mise en œuvre sur devis
            </p>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 scroll-indicator">
        <div className="scroll-line"></div>
      </div>
    </section>
  );
};

export default HeroSection;
